import Plpurl from '@tvg/product-listing-url';
import { SEOURLType } from '@tvg/product-listing-url/lib/Types/types';
import { FacetType } from 'common/types/facet';
import { Facet, FacetValue, Response } from 'common/types/search-response';

const GROUP_ID = 'group_id';
const SHOP_BY_PRODUCT = 'Shop By Product';

function instanceOfValue(object: any): object is FacetValue {
  return true;
}

const addSEOURLs = (groups: Facet[], plpurl: Plpurl) => {
  groups.forEach((group) => {
    group.values.forEach((value) => {
      if (instanceOfValue(value)) {
        value.url = plpurl.generateUrlForSEO(group.id, value.id, SEOURLType.addCategory);
      }
    });
  });
};

export const normalizeCategoryType = (data: Response, plpurl: Plpurl) => {
  if (!data || !data?.facet_list || data?.facet_list?.length === 0) return data;

  const facet_list_tmp: Facet[] = [];
  const groups_list_tmp: Facet[] = [];
  const shop_by_product_tmp: Facet[] = [];
  let mergedValues: FacetValue[] = [];
  data?.facet_list.forEach((facet) => {
    if (facet.type !== FacetType.category) facet_list_tmp.push(facet);
    if (facet.type === FacetType.category) {
      if (facet.name === '') shop_by_product_tmp.push(facet);
      else groups_list_tmp.push(facet);
    }
  });

  if (shop_by_product_tmp.length > 0) {
    mergedValues = shop_by_product_tmp.flatMap((obj) => obj?.values as FacetValue[]);
    groups_list_tmp.push({ id: GROUP_ID, name: SHOP_BY_PRODUCT, values: mergedValues });
  }

  addSEOURLs(groups_list_tmp, plpurl);

  data.facet_list = facet_list_tmp;
  Object.assign(data, {
    ...data,
    groups_list: groups_list_tmp,
  });

  return data;
};
